import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

export function ProtectedRoute({ children, adminOnly = false }) {
    const { user } = useAuth();
    const loc = useLocation();

    if (user === null) {
        return (
            <div className="min-h-screen grid place-items-center">
                <Loader2 className="animate-spin text-primary" size={28} />
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
    }
    if (adminOnly && user.role !== 'admin') {
        return <Navigate to="/" replace />;
    }
    return children;
}
